module.exports = __webpack_public_path__ + "static/img/zh-Hans.3bc0f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/zh-Hans.png
// module id = pHuL
// module chunks = 1